export type RoleTemplate = {
    id: string
    name: string
    jobDescription: string
}

export class RoleTemplateRegister {
    public static templates: RoleTemplate[] = [
        {
            id: 'software-engineer',
            name: 'Software Engineer',
            jobDescription: `We are looking for a skilled Software Engineer to join our dynamic team in Manchester, UK. The ideal candidate will have experience in developing high-quality software solutions, collaborating with cross-functional teams, and a passion for technology.`,
        },
        {
            id: 'business-analyst',
            name: 'Business Analyst',
            jobDescription: `We are looking for a detail-oriented Business Analyst to join our team. The ideal candidate will have experience in gathering and analyzing business requirements, creating functional specifications, and working closely with stakeholders to deliver high-quality solutions.`,
        },
        {
            id: 'technical-architect',
            name: 'Technical Architect',
            jobDescription: `We are looking for a talented Technical Architect to join our team. The ideal candidate will have expertise in software architecture, design patterns, and cloud technologies, along with a passion for building scalable and maintainable systems.`,
        },
        {
            id: 'qa',
            name: 'QA',
            jobDescription: `We are seeking a meticulous QA Engineer to join our team. The ideal candidate will have experience in creating and executing test plans, identifying defects, and ensuring the quality of software products through rigorous testing methodologies.`,
        },
        {
            id: 'talent-acquisition',
            name: 'Talent Acquisition',
            jobDescription: `We are looking for a proactive Talent Acquisition Specialist to join our HR team. The ideal candidate will have experience in sourcing, interviewing, and hiring top talent, along with a strong understanding of recruitment strategies and best practices.`,
        },
        {
            id: 'hr-manager',
            name: 'HR Manager',
            jobDescription: `We are seeking an experienced HR Manager to lead our human resources department. The ideal candidate will have expertise in employee relations, performance management, and compliance with labor laws, along with strong leadership and communication skills.`,
        },
    ]

    public static getTemplateById(id: string): RoleTemplate {
        const template = this.templates.find((template) => template.id === id)
        if (!template) {
            throw new Error(`Template with id ${id} not found`)
        }
        return template
    }
}
